<template>
  <div>
    <Card>
      <Row :gutter="16" style="margin-bottom: 16px;">
        <Col span="6">
          <Select v-model="filterStatus" placeholder="全部状态" clearable @on-change="handleSearch">
            <Option :value="''">全部</Option>
            <Option :value="0">待审核</Option>
            <Option :value="1">已通过</Option>
            <Option :value="2">已拒绝</Option>
          </Select>
        </Col>
      </Row>
      <tables
        ref="tables"
        v-model="tableData"
        :columns="columns"
        :total="pageTotal"
        :current="pageNum"
        :page-size="pageSize"
        @on-change-page="changePage"
        @on-page-size-change="handlePageSize"
      />
      <div style="margin: 10px; overflow: hidden">
        <div style="float: right;">
          <Page
            :total="pageTotal"
            :current="pageNum"
            :page-size="pageSize"
            :page-size-opts="[10, 15, 25, 50]"
            show-sizer
            show-total
            @on-change="changePage"
            @on-page-size-change="handlePageSize"
          />
        </div>
      </div>
    </Card>

    <!-- 审核弹窗 -->
    <Modal v-model="auditModal" title="审核注销申请" :loading="auditLoading" @on-ok="handleAudit">
      <Form :label-width="100">
        <FormItem label="用户ID">{{ currentRow.user_id }}</FormItem>
        <FormItem label="用户名">{{ currentRow.username }}</FormItem>
        <FormItem label="手机号">{{ currentRow.phone }}</FormItem>
        <FormItem label="申请时间">{{ currentRow.create_time }}</FormItem>
        <FormItem label="操作">
          <RadioGroup v-model="auditAction">
            <Radio label="agree"><span style="color: #ed4014;">同意注销</span></Radio>
            <Radio label="reject">拒绝</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="备注" v-if="auditAction === 'reject'">
          <Input v-model="auditRemark" type="textarea" placeholder="请输入拒绝原因" />
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import Tables from '_c/tables'
import { getAccountDeleteList, auditAccountDelete } from '@/api/account_delete'

export default {
  components: {
    Tables
  },
  data () {
    return {
      filterStatus: '',
      tableData: [],
      pageTotal: 0,
      pageNum: 1,
      pageSize: 15,
      columns: [
        {
          title: 'ID',
          key: 'id',
          width: 80
        },
        {
          title: '用户ID',
          key: 'user_id',
          width: 100
        },
        {
          title: '用户名',
          key: 'username',
          width: 120
        },
        {
          title: '手机号',
          key: 'phone',
          width: 130
        },
        {
          title: '申请时间',
          key: 'create_time',
          width: 180
        },
        {
          title: '状态',
          key: 'status',
          width: 100,
          render: (h, params) => {
            const status = params.row.status
            const map = { 0: '待审核', 1: '已通过', 2: '已拒绝' }
            const color = { 0: '#ff9900', 1: '#19be6b', 2: '#ed4014' }
            return h('Tag', { props: { color: color[status] } }, map[status] || '未知')
          }
        },
        {
          title: '审核人',
          key: 'audit_user',
          width: 100
        },
        {
          title: '审核时间',
          key: 'audit_time',
          width: 180
        },
        {
          title: '备注',
          key: 'remark',
          minWidth: 150
        },
        {
          title: '操作',
          key: 'action',
          width: 100,
          fixed: 'right',
          render: (h, params) => {
            if (params.row.status === 0) {
              return h('Button', {
                props: { type: 'warning', size: 'small' },
                on: { click: () => this.showAuditModal(params.row) }
              }, '审核')
            }
            return h('span', '-')
          }
        }
      ],
      auditModal: false,
      auditLoading: true,
      auditAction: 'agree',
      auditRemark: '',
      currentRow: {}
    }
  },
  methods: {
    loadData () {
      const params = {
        page: this.pageNum,
        page_size: this.pageSize
      }
      if (this.filterStatus !== '') {
        params.status = this.filterStatus
      }
      getAccountDeleteList(params).then(res => {
        if (res.data && res.data.code === 0) {
          this.tableData = res.data.data || []
          this.pageTotal = res.data.total || 0
        }
      })
    },
    handleSearch () {
      this.pageNum = 1
      this.loadData()
    },
    changePage (page) {
      this.pageNum = page
      this.loadData()
    },
    handlePageSize (size) {
      this.pageSize = size
      this.pageNum = 1
      this.loadData()
    },
    showAuditModal (row) {
      this.currentRow = row
      this.auditAction = 'agree'
      this.auditRemark = ''
      this.auditModal = true
    },
    handleAudit () {
      if (this.auditAction === 'agree') {
        this.$Modal.confirm({
          title: '确认注销',
          content: '<p style="color:#ed4014;font-size:16px;">确定要注销该账户吗？</p><p>此操作将永久删除用户数据且不可恢复！</p>',
          onOk: () => {
            this.doAudit()
          }
        })
      } else {
        if (!this.auditRemark.trim()) {
          this.$Message.warning('请填写拒绝原因')
          return
        }
        this.doAudit()
      }
    },
    doAudit () {
      const data = {
        id: this.currentRow.id,
        action: this.auditAction,
        remark: this.auditRemark,
        audit_user: this.$store.state.user.nickName
      }
      auditAccountDelete(data).then(res => {
        if (res.data && res.data.code === 0) {
          this.$Message.success(this.auditAction === 'agree' ? '账户已成功注销' : '已拒绝该申请')
          this.auditModal = false
          this.loadData()
        } else {
          this.$Message.error(res.data.msg || '操作失败')
        }
      })
    }
  },
  mounted () {
    this.loadData()
  }
}
</script>
